module.exports = __webpack_public_path__ + "media/swiper7.fc03b545.mp4";